import React from 'react';
import SalesLetterWrapper from './SalesLetterWrapper';
import CTAButton from './CTAButton';

const FinalCTALetter = () => {
  return (
    <SalesLetterWrapper id="pricing">
      <div className="text-center space-y-12">
        <h2 className="text-4xl md:text-6xl font-display font-black text-brand-dark leading-tight">
          Retirement Should Feel Flexible… <br/>
          <span className="text-brand-gold">Not Financially Stressful</span>
        </h2>
        
        <div className="space-y-8 text-xl md:text-2xl font-light text-text-secondary leading-relaxed max-w-3xl mx-auto">
          <p>The world has changed. Retirement has changed. But the good news is: <span className="text-brand-dark font-black">opportunity has changed too.</span></p>
          <p>Today, ordinary retirees have more opportunities than ever to create flexible income, portable work, and financial breathing room online.</p>
          <p className="text-brand-dark font-medium italic">Without: complicated technology, risky investments, or overwhelming business models.</p>
          <p className="text-2xl font-black text-brand-dark pt-6">You simply need the right guidance, a realistic roadmap, and a calm beginner-friendly starting point.</p>
        </div>

        <div className="bg-brand-green/5 p-12 rounded-[4rem] border-2 border-brand-green/20">
          <p className="text-2xl font-bold text-brand-dark mb-10">Click Below To Get Instant Access Today</p>
          <CTAButton className="scale-110" />
          <p className="mt-12 text-lg text-text-secondary leading-relaxed">
            And begin building more flexibility, more confidence, and more peace of mind in retirement.
          </p>
        </div>
      </div>
    </SalesLetterWrapper>
  );
};

export default FinalCTALetter;